import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { STATUS } from 'utils/constants'
import { locations } from 'rest/urls'
import { POST } from 'rest/request'
import { RootState } from 'store'

export const fetchLocations = createAsyncThunk<locations.LocationResponse, { body?: basic.Form, signal?: AbortSignal }>('location/fetchLocations', async ({ body, signal }) => {
  const response = await POST(locations, { body, signal })
  return response
})

const initialState: locations.LocationInitialState = {
  status: STATUS.idle,
  categories: {},
  places: {
    filtered: [],
    filteredAndLocalized: [],
    localized: [],
  },
}

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.status = STATUS.succeed
        state.places = action.payload.places
        state.categories = action.payload.categories.data.reduce((r, category) => {
          r[category.id] = category
          return r
        }, {} as Record<string, locations.Category>)
      })
      .addCase(fetchLocations.pending, (state, action) => {
        state.status = STATUS.pending
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        if (!action.meta.arg.signal?.aborted) {
          state.status = STATUS.failed
        }
      })
  }
})

export const selectLocationStatus = (state: RootState) => state.location.status
export const selectLocationPlaces = (state: RootState) => state.location.places
export const selectLocationCategories = (state: RootState) => state.location.categories

export default locationSlice.reducer
